import React from 'react';

const SectionHeader = ({ id, title, subtitle }) => (
  <div id={id} className="pt-20 pb-6 mb-6 border-b border-slate-700 scroll-mt-10">
    <h2 className="text-3xl font-bold text-white mb-2">{title}</h2>
    {subtitle && <p className="text-slate-400 text-lg">{subtitle}</p>}
  </div>
);

export default SectionHeader;